module.exports = __webpack_public_path__ + "img/banner_contact_mobile_768x300.0d2cb50e.jpg";